export default __webpack_public_path__ + "static/smellsLikeCoconut-6eb03a4528e82a6edf7491b576232120.png";